import { Injectable, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { map, of, Subject, switchMap } from 'rxjs';
import { v4 as uuidv4 } from "uuid";
import { CommonService } from '../../common/common.service';


@Injectable({
  providedIn: 'root'
})
export class RequestSyndicateService implements OnDestroy {
  private destroy$ = new Subject<void>();
  customerId: string;
  preferredCurrency: string;
  public checkApiPostReqProfileImg;
  public checkApiPostReqRemovePhoto;
  constructor(private router: Router, private injector: Injector, private authService: AuthService, private commonService: CommonService) {
    this.checkApiPostReqProfileImg = false;
    this.checkApiPostReqRemovePhoto = false;
    this.preferredCurrency = "GBP";
    this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap(userId => {
        if (!userId) {
          return of(null); // or EMPTY if you want no emission
        }
        this.customerId = userId;
        return userId;
      })
    );
  }

  // This function is used to get the request body for to validate request is validate or not
  private validateRequest(): boolean {
    return true;
  }

  // Get the claimable syndicates for the customer
  public getClaimableSyndicates() {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            module_name: "cliamable_syndicates",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }

  // This method is used to get the request body for the create private syndicate.

  public createSyndicateRequest(syndicateData) {
    let userId = null;
    this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    if (this.validateRequest()) {
      return {
        modules: [
          {
            website: "Lotto Social",
            website_id: "27",
            module_name: "create_private_syndicate",
            user_id: userId,
            syndicate_name: syndicateData?.title,
            image_url: syndicateData.image,
            type: syndicateData?.cardType,
            product_group: syndicateData.products,
            requestid: uuidv4(),
            document: "/api_post_request/create_private_syndicate",
          },
        ],
      };
    }
  }


  // This function creates a request to get a syndicate's details
  // The request is created using the syndicate id
  // The request will first be validated
  // [this function is not call anywhere so comment it ]

  public getSyndicateNumberRequest(syndicateId) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "4",
            screen_id: "4.6",
            action: "get_syndicate",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_private_syndicate_details",
            customer_id: this.customerId,
            private_syndicate_id: syndicateId,
          },
        ],
      };
    }
  }

  // This function is used for forming the request to get private syndicate offers   // [this function is not call anywhere so comment it ]

  public getSyndicateBigJackPotOffers() {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "4",
            screen_id: "4.7",
            action: "get_private_syndicate_offers",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_private_syndicate_ticket_confirmation_banner",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }

  // This function is used to form the request to create order id for PS syndicate payment
  public getCreateSyndicateOrderIdRequest(privateSyndicateCart) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            action: "create_order_id",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            page_id: "4",
            screen_id: "4.9.1",
            module_name: "create_order_id_for_PS_Payment",
            customer_id: this.customerId,
            ps_cart: privateSyndicateCart,
          },
        ],
      };
    }
  }


  // This function is used to get the request body for get paymil card details using syndicate id
  // [this function is not call anywhere so comment it ]
  public getPayMilCardsForSyndicatePayment(syndicateId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "4",
            screen_id: "4.10",
            action: "get_card_details",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_customer_paymill_card_details",
            customer_id: this.customerId,
            p_type: "10",
            from_process: "profile",
            private_syndicate_id: syndicateId,
          },
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "7",
            screen_id: "7.2",
            action: "profile_details",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_customer_details",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }


  // This function is used to get the request body for get tickets
  public getSyndicateTicketsRequest(syndicate_id, syndicate_type) {
    const userId = null;
    this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "6",
            screen_id: "6.2",
            action: "syndicate_ticket",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_tickets",
            customer_id: this.customerId,
            syndicate_id,
            syndicate_type,
          },
        ],
        collection: `/users/${userId}/syndicate_module`,
        mapKey: "syndicate_id",
      };
    }
  }

  // This function is used to get the request body for get syndicate draw ids   [this function is not call anywhere so comment it ]
  public getSyndicateStatusRequest(syndicateId, syndicateType) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            module_name: "get_syndicate_drawids",
            syndicate_id: syndicateId,
            customer_id: this.customerId,
            syndicate_type: syndicateType,
          },
        ],
      };
    }
  }


  // This function is used to get the request body for get syndicate size
  getSyndicateSizeRequest(syndicate: any) {
    return this.commonService.getUid("RequestSyndicateService").pipe(
      map((userId) => {
        if (!this.validateRequest) return null;

        return {
          modules: [
            {
              module_name: "get_syndicate_size",
              user_id: userId,
              syndicate_id:
                syndicate.id ||
                syndicate.psId ||
                syndicate.sId ||
                syndicate.encrypted_id,
              from_process: "mobile_app_user",
              syndicate_type: syndicate?.cardType,
            },
          ],
        };
      })
    );
  }

  // [this function is not call anywhere so comment it ]
  getInvitedSyndicateDataRequest(syndicateId, memberId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "12",
            screen_id: "12.1",
            action: "invited_on_login",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_invited_private_syndicate",
            customer_id: this.customerId,
            private_syndicate_id: syndicateId,
            refer_customer_id: memberId,
          },
        ],
      };
    }
  }

  // This function is used to get the request body for join in private syndicate
  public joinSyndicateInvitation(psId, invitedId, memberInviteId, status) {
    let userId = null;
    this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    if (this.validateRequest()) {
      return {
        modules: [
          {
            module_name: "join_private_syndicate",
            user_id: userId,
            private_syndicate_id: psId,
            invite_member_id: memberInviteId,
            join_status: status,
            requestid: uuidv4(),
            document: "/api_post_request/join_private_syndicate",
          },
        ],
      };
    }
  }

  /* Join syndicate via homepage card */

  getInvitedSyndicateDataValidationRequest(psId, referId) {
    let userId = null;
    this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    if (this.validateRequest()) {
      return {
        modules: [
          {
            module_name: "get_invited_private_syndicate_details",
            user_id: userId,
            private_syndicate_id: psId,
            refer_user_id: referId,
          },
        ],
      };
    }
  }

  // This function is used to get the request body for set payment holiday for user
  getSyndicatePaymentHolidayRequest(psId: string) {
    if (this.validateRequest()) {
      return this.commonService.getUid("RequestSyndicateService").pipe(
        map((userId) => ({
          modules: [
            {
              module_name: "set_payment_holiday",
              user_id: userId,
              syndicate_id: psId,
              requestid: uuidv4(),
              document: "/api_post_request/set_payment_holiday",
            },
          ],
        }))
      );
    }
  }

  // This function is used to get the request body for get all members from the private syndicate
  getSyndicateMembersRequest(syndicateId) {
    const userId = this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "5",
            screen_id: "5.1",
            action: "get syndicate meembers",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_private_syndicate_members",
            customer_id: this.customerId,
            private_syndicate_id: syndicateId,
          },
        ],
        collection: `/users/${userId}/syndicate_module`,
      };
    }
  }


  // This function is used to get the request body for get MGM social sharing details  [this function is not call anywhere so comment it ]
  getSyndicateMgmRequest() {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            action: "get_mgm_details",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            page_id: "5",
            screen_id: "5.2.1",
            module_name: "get_social_sharing",
            program_id: "9",
            mgm_type: "syndicate_mgm",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }
  // This function is used to get the request body for get winnings prize break down  [this function is not call anywhere so comment it ]
  getPrizeBreakdownRequest(claimEventId) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            page_id: "2",
            screen_id: "2..3",
            module_name: "get_prize_breakdown",
            customer_id: this.customerId,
            claim_type: "lottery",
            claim_event_id: claimEventId,
          },
        ],
      };
    }
  }


  // This function is used to get the request body for join in private syndicate   [this function is not call anywhere so comment it ]
  getJoinSyndicateRequest(syndicateId, inviteMemberId, groupId, status) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "12",
            screen_id: "12.2",
            action: "click_to_join",
            website: "Lotto Social",
            website_id: "33",
            group_id: groupId,
            source_site: "mobi.lottosocial.com",
            module_name: "join_private_syndicate",
            customer_id: this.customerId,
            private_syndicate_id: syndicateId,
            invite_member_id: inviteMemberId,
            join_status: status,
          },
        ],
      };
    }
  }

  // This function is used to get the request body for get leave syndicate request
  getPrivateSyndicateLeaveRequest(syndicateId, syndicateType, reason) {
    return this.authService.getUid$("RequestSyndicateService").pipe(
      switchMap((userId) => {
        if (this.validateRequest()) {
          return of({
            modules: [
              {
                module_name: "leave_syndicate",
                user_id: userId,
                param: {
                  syndicate_id: syndicateId,
                  stop_type: "pwa_user",
                  website_id: "33",
                  reason: reason,
                  syndicate_type: syndicateType?.toLowerCase(),
                },
                requestid: uuidv4(),
                document: "/api_post_request/leave_syndicate",
              },
            ],
          });
        } else {
          return of(null);
        }
      })
    );
  }
  // This function is used to get the request body for get syndicate page images  [this function is not call anywhere so comment it ]
  getSyndicateImages() {
    return {
      modules: [
        {
          page_id: 1,
          screen_id: 1,
          module_name: "get_syndicate_images_lib",
          customer_id: this.customerId,
        },
      ],
      collection: `/general_modules`,
    };
  }


  // This function is used to get the request body for get syndicate lotteries
  getSyndicateLotteries() {
    return {
      modules: [
        {
          page_id: 1,
          screen_id: 1,
          module_name: "get_syndicate_lotteries",
          customer_id: this.customerId,
        },
      ],
      collection: `/general_modules`,
    };
  }

  // This function is used to get the request body for get fork offer for the user. [this function is not call anywhere so comment it ]
  getSyndicateForkOffersRequest() {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            customer_id: this.customerId,
            action: "create_syndicateoffer_fork",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            page_id: "4",
            screen_id: "4.1.1",
            module_name: "get_fork_offer_for_you",
          },
        ],
      };
    }
  }

  // This function is used to get the request body for suspend/pause syndicate
  getPauseSyndicateRequest(syndicateId, type, getPauseSyndicateRequest: boolean = false) {

    if (this.validateRequest()) {
      return this.authService.getUid$("RequestSyndicateService").pipe(
        map((userId) => ({
          modules: [
            {
              module_name: "suspend_syndicate",
              user_id: userId,
              syndicate_id: syndicateId,
              from_process: "mobile_app_user",
              syndicate_type: type?.toLowerCase(),
              requestid: uuidv4(),
              document: "/api_post_request/suspend_syndicate",
              syndicate_pause_gift: getPauseSyndicateRequest,
            },
          ],
          // userId = userId;
        }))
      );

    }
    return of(null);
  }


  // This function is used to get the request body for leave private syndicate  [this function is not call anywhere so comment it ]
  getLeaveManagedSyndicateRequest(syndicateId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            action: "leave_private_syndicate",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            page_id: "12",
            screen_id: "12.3",
            module_name: "manage_syndicate",
            customer_id: this.customerId,
            syndicate_id: syndicateId,
            syndicate_type: "managed",
            syndicate_status: "CANCEL",
          },
        ],
      };
    }
  }

  // The ngOnDestroy() method, we emit a value and complete the destroy$ subject, which unsubscribes from the observable.
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
